import { Outlet } from 'react-router-dom'
import goleroLogo from '@/assets/images/golero-logo.svg'
import { LanguagePicker } from '@/components/LanguagePicker'
import { useDomTranslations } from '@/i18n'

export function AuthLayout() {
  useDomTranslations()

  return (
    <div className="auth-shell relative min-h-screen overflow-hidden">
      <div className="auth-backdrop-grid absolute inset-0" />
      <div className="auth-backdrop-overlay absolute inset-0" />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-10">
        <div className="absolute right-4 top-4 sm:right-6 sm:top-6">
          <LanguagePicker compact />
        </div>
        <img src={goleroLogo} alt="Golero" className="app-logo mb-8 h-8 w-auto sm:h-9" />

        <div className="w-full max-w-md">
          <div className="auth-card rounded-[1.5rem] border p-5 sm:p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
